import { RootState } from "../store";

export const clientSelector = (state: RootState) => state.clients;

export const dataUpdatesSelector = (state: RootState) =>
  state.clients.ui.dataUpdates;
